export default __webpack_public_path__ + "static/media/fight-loop-240.f2379c07.png";